import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { UserRole } from 'src/app/common/state/user/role/user-role';
import { User } from 'src/app/common/state/user/user.model';
import { UserState } from 'src/app/common/state/user/user.state';
import { FEATURE_FLAGS } from '../../shared/services/unleash/unleash.helpers';
import { UnleashService } from '../../shared/services/unleash/unleash.service';

@Component({
  selector: 'app-reporting-subnav',
  templateUrl: './reporting-subnav.component.html',
  styleUrls: ['./reporting-subnav.component.scss'],
  standalone: false,
})
export class ReportingSubNavComponent implements OnInit {
  user: User;

  evidenceReportEnabled: boolean;

  proformReportEnabled: boolean;

  PDReportsEnabled: boolean;

  @Input() districtCode: string;

  Roles = UserRole;

  selectedPath = '';

  customCollapsed = false;

  constructor(
    private store: Store,
    private featureFlagService: UnleashService,
    private router: Router
  ) {
    this.user = this.store.selectSnapshot(UserState.getUser) as User;
  }

  ngOnInit(): void {
    this.evidenceReportEnabled = this.featureFlagService.isEnabled(
      FEATURE_FLAGS.evidenceReporting
    );
    this.PDReportsEnabled = this.featureFlagService.isEnabled(
      FEATURE_FLAGS.PDReports
    );
    this.proformReportEnabled = this.featureFlagService.isEnabled(
      FEATURE_FLAGS.proformReporting
    );

    switch (this.router.url) {
      case '/reporting':
        this.selectedPath = 'Dashboard';
        break;

      case '/reporting/support-insights':
        this.selectedPath = 'Support Insights';
        break;

      case '/reporting/evidence':
        this.selectedPath = 'Evidence';
        break;

      case '/reporting/badge-progress':
        this.selectedPath = 'Growth';
        break;

      case '/reporting/observations':
        this.selectedPath = 'Observation';
        break;

      case '/reporting/proforms':
        this.selectedPath = 'ProForms';
        break;

      case '/reporting/credits-earned':
        this.selectedPath = 'Credits';
        break;

      case '/reporting/pd-session-summary':
        this.selectedPath = 'Learning & Events';
        break;

      case '/reporting/session-details':
        this.selectedPath = 'Session Details';
        break;

      case '/reporting/plans':
        this.selectedPath = 'Plans';
        break;

      default:
        this.selectedPath = 'DEFAULT';
        break;
    }
  }

  toggleCustomCollapsed(): void {
    this.customCollapsed = !this.customCollapsed;
  }
}
